<div class="panel-header-container" [formGroup]="subContractorsCostsFormGroup">
    <div class="panel-header-row">

        <button mat-icon-button (click)="isSubcontractorsCostsExpanded = !isSubcontractorsCostsExpanded"
            class="button-expand-collapse">
            <mat-icon class="icon-expand-collapse">
                {{isSubcontractorsCostsExpanded ? 'expand_more' : 'chevron_right'}}
            </mat-icon>
        </button>
        <table class="full-width">
            <tr class="custom-table-row">
                <td class="estimate-table-column width-190">{{ 'SUBCONTRACTORS_COSTS' | translate}}</td>
                <td class="estimate-table-column width-110">
                    {{ subContractorsCostsFormGroup.controls.headerRow.controls.cost.value | multilingualCurrency }}
                </td>
                <td class="estimate-table-column width-70"></td>
                <td class="estimate-table-column width-70">
                    {{ subContractorsCostsFormGroup.controls.headerRow.controls.tdcPercentage.value | decimalPrecision
                    }}%
                </td>
                <td class="estimate-table-column width-70">
                    <ng-container *ngIf=" isMarkUpSelected; else subContractorsCostsGrossMarginPercentage">
                        {{ subContractorsCostsFormGroup.controls.headerRow.controls.markUpPercentage.value |
                        decimalPrecision }}%
                    </ng-container>
                    <ng-template #subContractorsCostsGrossMarginPercentage>
                        {{ subContractorsCostsFormGroup.controls.headerRow.controls.grossMarginPercentage.value |
                        decimalPrecision }}%
                    </ng-template>
                </td>
                <td class="estimate-table-column width-210 padding-gm">
                    {{ subContractorsCostsFormGroup.controls.headerRow.controls.grossMargin.value | multilingualCurrency
                    }}
                </td>
                <td class="estimate-table-column width-110">
                    {{ subContractorsCostsFormGroup.controls.headerRow.controls.sellPrice.value | multilingualCurrency
                    }}
                </td>
            </tr>
        </table>
    </div>

    <div *ngIf="isSubcontractorsCostsExpanded">

        <div class="table-container margin-left-28">
            <table class="full-width">
                <tr class="table-row-container"
                    *ngFor="let rowGroup of subContractorsCostsFormArray.controls; let i = index; trackBy: trackBySubContractorsCostsListIndex"
                    [formGroup]="rowGroup">
                    <td class="estimate-table-column width-190">{{ rowGroup.controls.name.value }}</td>
                    <td class="estimate-table-column width-110">
                        {{ rowGroup.controls.cost.value | multilingualCurrency }}
                    </td>
                    <td class="estimate-table-column width-70"></td>
                    <td class="estimate-table-column width-70">
                        {{ rowGroup.controls.tdcPercentage.value | decimalPrecision }}%
                    </td>
                    <td class="estimate-table-column width-70">
                        <ng-container *ngIf="sellAsPricingMode === solEstimatePricingMode.Line_Item; else notLabor">
                            <ng-container *ngIf="isMarkUpSelected; else notMarkUp">
                                <mat-form-field appearance="outline"
                                    class="no-padding-input mat-input-alignment width-70 margin-field"
                                    [class.margin-field-changed]="!rowGroup.controls.isSellPriceLastModified.value">
                                    <input matInput
                                        [appNumericMask]="solEstimateTableCommonFunctionsService.calculatedPercentageConfig"
                                        inputmode="decimal" formControlName="markUpPercentage"
                                        class="input-alignment" />
                                </mat-form-field>
                            </ng-container>
                            <ng-template #notMarkUp>
                                <mat-form-field appearance="outline"
                                    class="no-padding-input mat-input-alignment width-70 margin-field"
                                    [class.margin-field-changed]="!rowGroup.controls.isSellPriceLastModified.value">
                                    <input matInput
                                        [appNumericMask]="solEstimateTableCommonFunctionsService.calculatedPercentageConfig"
                                        inputmode="decimal" formControlName="grossMarginPercentage"
                                        class="input-alignment" />
                                </mat-form-field>
                            </ng-template>
                        </ng-container>
                        <ng-template #notLabor>
                            <ng-container *ngIf="isMarkUpSelected; else notMarkUp">
                                {{ rowGroup.controls.markUpPercentage.value | decimalPrecision }}%
                            </ng-container>
                            <ng-template #notMarkUp>
                                {{ rowGroup.controls.grossMarginPercentage.value | decimalPrecision }}%
                            </ng-template>
                        </ng-template>
                    </td>
                    <td class="estimate-table-column width-210 padding-gm">
                        {{ rowGroup.controls.grossMargin.value | multilingualCurrency }}
                    </td>
                    <td class="estimate-table-column width-110">
                        <ng-container
                            *ngIf="sellAsPricingMode === solEstimatePricingMode.Line_Item; else noInputSellPrice">
                            <mat-form-field class="no-padding-input mat-input-alignment width-110" appearance="outline"
                                [class.sell-price-changed]="rowGroup.controls.isSellPriceLastModified.value">
                                <input matInput
                                    [appNumericMask]="solEstimateTableCommonFunctionsService.sellPriceConfig"
                                    [showStepper]="false" inputmode="decimal" formControlName="sellPrice"
                                    class="input-alignment" />
                            </mat-form-field>
                        </ng-container>
                        <ng-template #noInputSellPrice>
                            {{ rowGroup.controls.sellPrice.value | multilingualCurrency }}
                        </ng-template>
                    </td>
                </tr>
            </table>
        </div>

    </div>
</div>